/* global smartFilter */
import { q, qq } from "../../helper/q"
import { closeOpenSorting } from "./sorting"

export const catalogFilter = () => {
  const filterElements = qq(".productsFilterForm .productsFilterElement")

  if (filterElements) {
    filterElements.map(filterElement => {
      const button = q(".productsFilterButton", filterElement)
      button.addEventListener("click", e => {
        if (button.parentNode.classList.contains("productsFilterElementActive")) {
          smartFilter.hideFilterProps(e.target)
          return null
        }
        closeOpenSorting()
        filterElements.map(filterElement => {
          if (filterElement.classList.contains("productsFilterElementActive")) {
            filterElement.classList.remove("productsFilterElementActive")
            filterElement.classList.remove("bx-active")
            q(".productsFilterParameters", filterElement).style = null
          }
        })
        smartFilter.hideFilterProps(e.target)
      })
    })
  }
}

export const closeOpenFilter = () => {
  const filterElements = qq(".productsFilterForm .productsFilterElement")
  filterElements.map(filterElement => {
    if (filterElement.classList.contains("productsFilterElementActive")) {
      filterElement.classList.remove("productsFilterElementActive")
      filterElement.classList.remove("bx-active")
      q(".productsFilterParameters", filterElement).style = null
    }
  })
}
